import { Api } from '@jcd-web/basic-api';
export class MailApi extends Api {
    static contact(contact) {
        return MailApi.client.post('/contact', contact);
    }
}
MailApi.baseUrl = '/api/mail/';
